module.exports = __webpack_public_path__ + "img/role05.4d2c8b70.png";